import { Routes } from '@angular/router';
import { HomePageComponent } from '@features/pages/home-page/home-page.component';
import { ProductionGamePlayComponent } from '@features/games/pages/production-game-page/components/production-game-play/production-game-play.component';
import { ProductionGameRankComponent } from '@features/games/pages/production-game-page/components/production-game-rank/production-game-rank.component';
import { ProductionGameRateComponent } from '@features/games/pages/production-game-page/components/production-game-rate/production-game-rate.component';
import { ProductionGamePageComponent } from '@features/games/pages/production-game-page/production-game-page.component';
import { AuthCallbackComponent } from '@shared/components/auth-callback/auth-callback.component';
import { LogoutComponent } from '@shared/components/logout/logout.component';
import { EditionPageComponent } from '@features/pages/edition-page/edition-page.component';
import { ProgrammePageComponent } from '@features/pages/programme-page/programme-page.component';

export const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
    pathMatch: 'full'
  },
  {
    path: 'edition/:id',
    component: EditionPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'programme/:id',
    component: ProgrammePageComponent,
    pathMatch: 'full'
  },
  {
    path: 'callback',
    component: AuthCallbackComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  /*{
    path: 'happening',
    component: UpcomingPageComponent,
    children: [
      {
        path: ':id',
        component: SeasonDetailsComponent
      }
    ]
  },*/
  {
    path: 'games/gamedetails/:gameDetailsId',
    component: ProductionGamePageComponent,
    children: [
      {
        path: 'rank',
        component: ProductionGameRankComponent
      },
      {
        path: 'rate',
        component: ProductionGameRateComponent
      },
      {
        path: 'play',
        component: ProductionGamePlayComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
